import { ReactNode } from "react";

export function DisclosureCard({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <details className="group rounded-xl border border-f4f7ff bg-white">
      <summary className="flex min-h-[56px] w-full cursor-pointer list-none items-center justify-between gap-4 rounded-xl px-4 py-4 text-left transition-colors hover:bg-f4f7ff focus-visible:outline focus-visible:outline-2 focus-visible:outline-3461fd [&::-webkit-details-marker]:hidden">
        <span className="min-w-0">
          <span className="block text-sm font-semibold text-191c20">
            {title}
          </span>
          {description && (
            <span className="mt-1 block text-xs text-858494">
              {description}
            </span>
          )}
        </span>
        <svg
          viewBox="0 0 20 20"
          fill="none"
          aria-hidden="true"
          className="h-5 w-5 flex-shrink-0 text-858494 transition-transform group-open:rotate-180"
        >
          <path
            d="m5 7.5 5 5 5-5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </summary>
      <div className="space-y-5 border-t border-f4f7ff px-4 py-4">
        {children}
      </div>
    </details>
  );
}
